import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OfferEntryData} from '../../../core/models/offerEntryData';
import {GridSetting} from '../../models/grid-setting';


@Component({
    selector: 'app-add-registration-child',
    templateUrl: './add-registration-child.component.html',
    styleUrls: ['./add-registration-child.component.css']
})
export class AddRegistrationChildComponent implements OnInit {
    setting: GridSetting = new GridSetting();

    @Input() offerEntryDataInput: OfferEntryData;
    @Output() buttonEvent = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit() {
        this.setting = new GridSetting();
        this.setting.sorting = false;
        this.setting.charting = false;
        this.setting.datePicker = false;
        this.setting.deratingFactor = false;
        this.setting.expansion = false;
        this.setting.contextMenu = false;
        this.setting.message = false;
        this.setting.sendSaveChangesMessage = false;
    }

    addClicked() {
        this.buttonEvent.emit({offerEntryData: this.offerEntryDataInput});
    }

    cancelClicked() {
        this.buttonEvent.emit('Cancel');
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/add-registration-child/add-registration-child.component.ts